module.exports = ".magazine-events-calendar {\n  height: 390px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/magazine/magazine-events/magazine-events.component.scss
// module id = ./src/app/magazine/magazine-events/magazine-events.component.scss
// module chunks = magazine.module